import React, { Component } from 'react';
import App from '../routes/App';
import styles from './styles.scss';

export default class Default extends Component 
{
    render() 
    {
        return (
          <div className={styles.app_container}>
            <App/>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Default.js